import { darkTheme, lightTheme } from '../../theme';
import { DARK } from '../../utils/constants';

export default theme => {
  const currentTheme = theme === DARK ? darkTheme : lightTheme;

  return {
    control: base => ({
      ...base,
      padding: '1px 5px',
      fontSize: '14px',
      borderColor: currentTheme.palette.secondary.light5,
      boxShadow: 'none',
      outline: 'none',
      borderRadius: 0,
      '&:hover': {
        borderColor: currentTheme.palette.brand.primary,
        outline: 'none',
      },
    }),
    option: (styles, { data, isSelected }) => ({
      ...styles,
      fontStyle: data.value === 'uid-not-found' ? 'italic' : 'normal',
      borderBottom: 'none',
      backgroundColor: isSelected
        ? `${currentTheme.palette.secondary.main} !important`
        : data.value === 'uid-not-found'
        ? currentTheme.palette.secondary.light7
        : currentTheme.palette.brand.secondary1,
      color: currentTheme.palette.brand.primary,
      cursor: 'pointer',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: currentTheme.palette.secondary.light,
      },
    }),
    indicatorSeparator: base => ({
      ...base,
      width: 0,
    }),
    menu: base => ({
      ...base,
      zIndex: 5,
      top: 'calc(100% - 8px)',
      borderRadius: 0,
      backgroundColor: currentTheme.palette.brand.secondary1,
    }),
    noOptionsMessage: base => ({
      ...base,
      textAlign: 'left',
    }),
    loadingMessage: base => ({
      ...base,
      textAlign: 'left',
    }),
    singleValue: provided => ({
      ...provided,
      color: currentTheme.palette.brand.primary,
    }),
  };
};
